import { isScrapingSourceType, SOURCE_TYPE } from '@/types/feedbackConst';

import { AppleAppStoreItem } from '../../providers/AppleAppStore/AppleAppStoreItem';
import { AtlasItem } from '../../providers/Atlas/AtlasItem';
import { ChannelTalkItem } from '../../providers/Channeltalk/ChanneltalkItem';
import { DiscordItem } from '../../providers/Discord/DiscordItem';
import { FreshdeskItem } from '../../providers/Freshdesk/FreshdeskItem';
import { FrontItem } from '../../providers/Front/FrontItem';
import { G2Item } from '../../providers/G2/G2Item';
import { GongItem } from '../../providers/Gong/GongItem';
import { GooglePlayStoreItem } from '../../providers/GooglePlayStore/GooglePlayStoreItem';
import { GorgiasItem } from '../../providers/Gorgias/GorgiasItem';
import { HelpScoutItem } from '../../providers/HelpScout/HelpScoutItem';
import { IntercomItem } from '../../providers/Intercom/IntercomItem';
import { KnocommerceItem } from '../../providers/Knocommerce/KnocommerceItem';
import { KustomerItem } from '../../providers/Kustomer/KustomerItem';
import { OkendoItem } from '../../providers/Okendo/OkendoItem';
import { QualtricsItem } from '../../providers/Qualtrics/QualtricsItem';
import { RichpanelItem } from '../../providers/Richpanel/RichpanelItem';
import { SalesforceItem } from '../../providers/Salesforce/SalesforceItem';
import { ScrapingSourceItem } from '../../providers/ScrapingSource/ScrapingSourceItem';
import { SlackItem } from '../../providers/Slack/SlackItem';
import { StampedItem } from '../../providers/Stamped/StampedItem';
import { TrustpilotItem } from '../../providers/Trustpilot/TrustpilotItem';
import { TypeformItem } from '../../providers/Typeform/TypeformItem';
import { YotpoItem } from '../../providers/Yotpo/YotpoItem';
import { ZendeskItem } from '../../providers/Zendesk/ZendeskItem';
import type { IntegrationItem } from '../../types';

type Props = {
  source: SOURCE_TYPE;
  item?: IntegrationItem;
  onScraperSelectCallback?: (source: SOURCE_TYPE) => void;
};

export const SourceMapper = (props: Props) => {
  switch (props.source) {
    case SOURCE_TYPE.SLACK:
      return <SlackItem isConnector={!props.item} />;
    case SOURCE_TYPE.INTERCOM:
      return <IntercomItem isConnector={!props.item} />;
    case SOURCE_TYPE.ZENDESK:
      return <ZendeskItem isConnector={!props.item} />;
    case SOURCE_TYPE.GORGIAS:
      return <GorgiasItem isConnector={!props.item} />;
    case SOURCE_TYPE.KUSTOMER:
      return <KustomerItem isConnector={!props.item} />;
    case SOURCE_TYPE.KNOCOMMERCE:
      return <KnocommerceItem isConnector={!props.item} />;
    case SOURCE_TYPE.HELPSCOUT:
      return <HelpScoutItem isConnector={!props.item} />;
    case SOURCE_TYPE.STAMPED:
      return <StampedItem isConnector={!props.item} />;
    case SOURCE_TYPE.OKENDO:
      return <OkendoItem isConnector={!props.item} />;
    case SOURCE_TYPE.TRUSTPILOT:
      return <TrustpilotItem isConnector={!props.item} />;
    case SOURCE_TYPE.GONG:
      return <GongItem isConnector={!props.item} />;
    case SOURCE_TYPE.TYPEFORM:
      return <TypeformItem isConnector={!props.item} />;
    case SOURCE_TYPE.SALESFORCE:
      return <SalesforceItem isConnector={!props.item} />;
    case SOURCE_TYPE.YOTPO:
      return <YotpoItem isConnector={!props.item} />;
    case SOURCE_TYPE.ATLAS:
      return <AtlasItem isConnector={!props.item} />;
    case SOURCE_TYPE.DISCORD:
      return <DiscordItem isConnector={!props.item} />;
    case SOURCE_TYPE.RICH_PANEL:
      return <RichpanelItem isConnector={!props.item} />;
    case SOURCE_TYPE.CHANNELTALK:
      return <ChannelTalkItem isConnector={!props.item} />;
    case SOURCE_TYPE.FRONT:
      return <FrontItem isConnector={!props.item} />;
    case SOURCE_TYPE.FRESHDESK:
      return <FreshdeskItem isConnector={!props.item} />;
    case SOURCE_TYPE.APPLE_APP_STORE:
      return <AppleAppStoreItem isConnector={!props.item} />;
    case SOURCE_TYPE.GOOGLE_PLAY:
      return <GooglePlayStoreItem isConnector={!props.item} />;
    case SOURCE_TYPE.G2:
      return <G2Item isConnector={!props.item} />;
    case SOURCE_TYPE.QUALTRICS:
      return <QualtricsItem isConnector={!props.item} />;
    default: {
      if (isScrapingSourceType(props.source)) {
        if (!props.item) return null;
        return (
          <ScrapingSourceItem
            sourceType={props.source}
            status={props.item?.status}
            desc={props.item?.cause}
            onClick={() => {
              props.onScraperSelectCallback?.(props.source);
            }}
          />
        );
      }
      return null;
    }
  }
};
